import { faAdversal } from "@fortawesome/free-brands-svg-icons";
import {
	faAddressCard,
	faBlog,
	faHome,
	faHotel,
	faImages,
	faLayerGroup,
	faSearchPlus,
	faTags,
	faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { NAV_REDUCER_GET_NAV_DATA } from "../common/constants";

const fetchNavDataFromServer = (userData) => {
	console.log(userData);
	const host = new URL(window.location.href)?.host;
	if (
		userData?.roles?.reduce(
			(val, role) => val || (role?.id === 1 && role?.name === "admin"),
			false
		)
	) {
		return [
			{
				label: "Users",
				link: "Users",
				icon: faUsers,
			},
			{
				label: "Properties",
				link: "Properties",
				icon: faHotel,
			},
			{
				label: "Home Sections",
				link: "HomeSections",
				icon: faHome,
			},
			{
				label: "Category",
				link: "PropertyCategory",
				icon: faLayerGroup,
			},
			{
				label: "Tag",
				link: "PropertyTag",
				icon: faTags,
			},
			{
				label: "Contact Request",
				link: "ContactRequest",
				icon: faAddressCard,
			},
			{
				label: "Advertises",
				link: "Advert",
				icon: faAdversal,
			},
			{
				label: "Search Score",
				link: "SearchScore",
				icon: faSearchPlus,
			},
			{
				label: "Image Resources",
				link: "ImageResources",
				icon: faImages,
			},
			{
				label: "Blogs",
				link:
					new URL(window.location.href).protocol +
					"//" +
					(host.match(/.*jorooms\.com/)?.length
						? host
						: host.replace(/:\d+/, "") + ":8000") +
					"/admin/blog",
				icon: faBlog,
			},
		];
	} else {
		return [
			{
				label: "Properties",
				link: "Properties",
				icon: faHotel,
			},
		];
	}
};

const NavReducer = (state, action) => {
	switch (action.type) {
		case NAV_REDUCER_GET_NAV_DATA:
			return fetchNavDataFromServer(action.payload);

		default:
			break;
	}
};

export default NavReducer;
